export const FILTER_THIS_WEEK = 'this_week';
export const FILTER_LAST_MONTH = 'last_month';
export const FILTER_PAST_THREE_MONTH = 'past_3_months';
export const FILTER_CUSTOM = 'custom';